

import styled from 'styled-components';
import { FlexBox } from '@brg/ui';

export const NavbarIconWidget = styled(FlexBox)`
    height: 64px;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    opacity: 0.47;
    transition: opacity 0.2s;
    &:hover {
        opacity: 1;
    }
`;


import styled from 'styled-components';
import { FlexBox } from '@brg/ui';

export const NavbarIconWidget = styled(FlexBox)`
    height: 64px;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    opacity: 0.47;
    transition: opacity 0.2s;
    &:hover {
        opacity: 1;
    }
`;
